<script>
    export let diameter = 158
</script>

<div class="basic-style {$$props.class || ''}" style={`width: ${diameter}px; height: ${diameter}px; ${$$props.style}`}>
    <slot />
</div>

<style lang="scss" module>
    .basic-style {
        position: relative;
        border-radius: 100%;
        border: 1px solid rgb(238, 236, 236);
        background: linear-gradient(42.32deg, rgba(255, 215, 184, 0.34) 12.81%, rgba(255, 197, 151, 0) 88.82%);
        backdrop-filter: blur(30px);
    }
</style>